<script>
  import { createEventDispatcher, onDestroy } from 'svelte';
  import ComponentEvents from '@utils/component-events';

  import jQuery from 'jquery';

  export let contributorView = true;
  export let withMobileFooter = true;
  export let withAddComment = false;

  const dispatch = createEventDispatcher();
  const dispatchClick = () => {
    dispatch('click');
  };

  let locationTimeout;
  const unsubCurrentSection = ComponentEvents.on('current-section', (data) => {
    if (data && data.section) {
      if (locationTimeout) {
        clearTimeout(locationTimeout);
        locationTimeout = undefined;
      }

      locationTimeout = setTimeout(() => {
        locationTimeout = undefined;
        setLocationBasedOnViewerType();
      }, 100);
    }
  });

  const setLocationBasedOnViewerType = () => {
    let bottom;

    if (withAddComment) {
      bottom = 214;
    } else if (withMobileFooter) {
      bottom = 144;
    } else {
      bottom = 90;
    }

    const topBuffer = 30;
    const topHeader = 60;
    const currentSectionHeight = jQuery('.m-current-section').outerHeight() || 0;
    const paddingOverlap = currentSectionHeight === 0 ? 0 : 20;
    const top = topBuffer + topHeader + currentSectionHeight - paddingOverlap;

    const contribLocationStyles = [`top: ${top}px`, `bottom: unset`].join('; ');
    const viewerLocationStyles = [`top: unset`, `bottom: ${bottom}px`].join('; ');

    const locationStyles = contributorView ? contribLocationStyles : viewerLocationStyles;

    const currentStyle = jQuery('.m-map-button').attr('style');
    jQuery('.m-map-button').attr('style', `${currentStyle}; ${locationStyles}`);
  };

  onDestroy(() => {
    unsubCurrentSection();
  });
</script>

<style style="text/scss" lang="scss">
  $width: 108px;
  $height: 36px;
  $y: 150px;

  .m-map-button {
    position: fixed;
    z-index: 4;
    top: $y;
    left: calc(50vw - $width / 2);
    width: $width;
    height: $height;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 75px;
    border: 0px;

    transition: top 0.15s;
  }

  .m-map-button__content {
    width: 100%;
    height: 100%;
    padding: 0px 20px;

    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .m-map-button__image {
    height: 12px;
    width: 12px;
  }

  .m-map-button__text {
    font-size: 14px;
    font-weight: 500;
    color: white;
  }
</style>

<button class="m-map-button" on:click={dispatchClick} use:setLocationBasedOnViewerType>
  <div class="m-map-button__content">
    <img class="m-map-button__image" src="/images/map/marker-white.svg" alt="M" />
    <span class="m-map-button__text">Map</span>
  </div>
</button>
